const POSTAL_CODE_RULES_BY_COUNTRY_CODE: Record<string, RegExp> = {
  DE: /^\d{5}$/,
  AT: /^[1-9]\d{3}$/,
  CH: /^[1-9]\d{3}$/,
  FR: /^\d{5}$/,
  NL: /^[1-9]\d{3}\s?[A-Z]{2}$/i,
}

export function isPostalCodeFormatValidForCountry(postalCode: string, countryCode: string | undefined): boolean {
  const rule = countryCode ? POSTAL_CODE_RULES_BY_COUNTRY_CODE[countryCode.toUpperCase()] : undefined
  if (!rule) {
    return true
  }

  return rule.test(postalCode.trim())
}
